<template>
	<div>
		<header v-if="device == 'true'">
			<div class="back" @click="goBack"><img src="../../../asset/back.png" alt=""></div>
		</header>
		<div class="welcome">欢迎登陆小白考研</div>
		
		
		<div class="tel">
			<span>+86</span>
			<input type="number" v-model="tel" @input="number_input()" maxlength="11" placeholder="请输入手机号">
		</div>
		<div class="confirm">登陆注册代表你已同意<span @click="go1">用户协议</span>和<span @click="go2">隐私政策</span></div>
		<div :class="nextBtn?'nextBtnyes nextBtn':'nextBtnno nextBtn' " class="" @click="goNext">下一步</div>
		<div class="qeihuan" @click="goLogin">密码登录</div>
		
		
		
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';

	export default {
		data() {
			return {
				tel: '',
				nextBtn:false,
				device:"true"
			}
		},
		created() {
			var storage = window.sessionStorage;
			var device = storage.getItem('device')
      this.route = this.$route.query.route;
      console.log("route",this.route)
			if(device){
				this.device = device
			}
		},
		methods: {
			goLogin(){
				this.$router.push({
					name: 'loginCode',
					query: {
						tel: this.tel,
						qeihuan:false,
            route:this.route,
					}
				})
			},
			goBack() {
				this.$router.go(-1)
			},
			number_input(){
				
				if(/^1\d{10}$/.test(this.tel)){
					console.log("验证通过")
					this.nextBtn = true
				}else{
					console.log("验证失败")
					this.nextBtn = false
				}
			},
			animate(){
			          /^1\d{10}$/.test(this.tel) ? this.$router.push({
			          	name: 'loginCode',
			          	query: {
			          		tel: this.tel,
                    route:this.route,
			          	}
			          }) : Toast.loading({
			          	message: '手机号格式错误',
			          	forbidClick: true,
			          });
			       },
			goNext() {

				/^1\d{10}$/.test(this.tel) ? this.$router.push({
					name: 'loginCode',
					query: {
						tel: this.tel,
            route:this.route,
					}
				}) : Toast.loading({
					message: '手机号格式错误',
					forbidClick: true,
				});
				console.log()
			},
			go1(){
				window.location.href='https://app.xiaobaikaoyan.com/protocol'
			},
			go2(){
				window.location.href='https://app.xiaobaikaoyan.com/privacy'
			}
		}
	}
</script>

<style scoped="scoped">
	header {
		width: 750px;
		height: 88px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		background: #FFFFFF;
	}
	.qeihuan{
		font-size: 30px;
		text-align: center;
		line-height: 30px;
		margin-top: 20px;
		padding: 20px;
	}
	.back {
		width: 28px;
		height: 28px;
		margin-left: 30px;
	}

	.back img {
		width: 100%;
	}

	.welcome {
		width: 606px;
		margin: 0 auto;
		font-size: 50px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 48px;
		padding: 86px 0 0 0;
	}

	.tel {
		font-size: 30px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 42px;
		width: 606px;
		border-bottom: 1px solid #D7D7D7;
		display: flex;
		align-items: center;
		padding: 26px 0;
		margin: 88px auto 22px auto;
	}

	.tel span {
		position: relative;
	}

	.tel span:after,
	.tel span:before {
		border: 12px solid transparent;
		border-left: 12px solid #fff;
		width: 0;
		height: 0;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: -40px;
		content: ' '
	}

	.tel span:before {
		border-left-color: #000;
		right: -40px;
	}

	.tel input {
		margin-left: 70px;
		outline: none;
		border: none;
		background-color: rgba(0,0,0,0);
	}

	.confirm {
		font-size: 26px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 37px;
		width: 606px;
		margin: 0 auto;
	}

	.confirm span {
		color: #3F94FF;
	}
	
	.nextBtn {
		width: 607px;
		height: 88px;
		background: #A5CDFF;
		border-radius: 44px;
		margin: 0 auto;
		font-size: 30px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 78px;
	}
	.nextBtnyes{
		background: #3F94FF;
	}
	.nextBtnno{
		background: #A5CDFF;
	}
</style>
